import { Button, Card, Typography } from '@mui/material';
import { styled, type Theme } from '@mui/material/styles';

export const CheckoutCard = styled(Card)({
  padding: '10px',
  marginBottom: '20px',
  borderRadius: '10px',
});

export const CheckoutCardHeader = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '16px',
  marginBottom: '10px',
});

const buttonStyle = ({ theme }: { theme: Theme }) => ({
  width: '100px',
  padding: '2px',
  boxShadow: 'none',
  [theme.breakpoints.up('sm')]: {
    width: '150px',
  },
  '&:hover': {
    backgroundColor: theme.palette.secondary.dark,
    boxShadow: 'none',
  },
});

export const CheckoutButton = styled(Button)(buttonStyle);
